<template>
  <div>
    <Banners
      :src="require('@/assets/img/aboutUs/banner.jpg')"
      title="关于我们"
      text="专业人才终身赋能"
      textTwo="企业服务全程陪伴"
    ></Banners>
    <b-container class="about">
      <b-row>
        <b-col cols="12" md="3">
          <div class="about-left">
            <div
              :class="[
                tab == 'introduction'
                  ? 'about-left-text active'
                  : 'about-left-text'
              ]"
              @click="tabClick('introduction')"
            >
              <h5>公司介绍</h5>
              <p>INTRODUCTIO</p>
            </div>
            <!-- <div
              :class="[
                tab == 'team' ? 'about-left-text active' : 'about-left-text'
              ]"
              @click="tabClick('team')"
            >
              <h5>团队介绍</h5>
              <p>OUR TEAM</p>
            </div>-->
            <div
              :class="[
                tab == 'contact' ? 'about-left-text active' : 'about-left-text'
              ]"
              @click="tabClick('contact')"
            >
              <h5>联系我们</h5>
              <p>CONTACT US</p>
            </div>
            <div
              :class="[
                tab == 'join' ? 'about-left-text active' : 'about-left-text'
              ]"
              @click="tabClick('join')"
            >
              <h5>加入我们</h5>
              <p>JOIN US</p>
            </div>
          </div>
        </b-col>
        <b-col cols="12" md="9" class="about-right">
          <!-- 团队 -->
          <!-- <div v-if="tab == 'team'">
            <b-row class="about-team">
              <b-col
                cols="12"
                md="4"
                v-for="(item, index) of teamData.data"
                :key="index"
              >
                <img :src="getImgUrl(item.avatar)" alt />
                <div class="team-text">
                  <div class="team-text-pos">
                    <h5>{{ item.name }}</h5>
                    <p>{{ item.title }}</p>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-pagination
              v-if="teamData.data && teamData.data.length > 0"
              class="company-page"
              style="justify-content: center;"
              v-model="page.current"
              :total-rows="page.rows"
              limit="4"
              :perPage="page.perPage"
              first-number
              last-number
            ></b-pagination>
          </div>-->
          <router-view />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Banners from "@/components/banner/Banners.vue";
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  name: "aboutUs",
  data() {
    return {
      page: {
        current: 1,
        rows: 1,
        perPage: 6
      },
      tab: "company",
      teamData: [
        {
          src: require("@/assets/img/aboutUs/banner.png"),
          name: "张秉承",
          text: "创始人&CEO"
        }
      ],
      CompanyData: []
    };
  },
  mounted() {
    this.watchTab();
  },
  watch: {
    $route: "watchTab"
  },
  //   watch: {
  //     "page.current": {
  //       deep: true,
  //       handler: function() {
  //         this.getCompany();
  //         window, scrollTo(0, 0);
  //       }
  //     }
  //   },
  components: {
    Banners
  },
  methods: {
    watchTab() {
      const router = this.$route.path;
      console.log(router);
      if (router.indexOf("introduction") > -1) {
        this.tab = "introduction";
      } else if (router.indexOf("contact") > -1) {
        this.tab = "contact";
      } else if (router.indexOf("join") > -1) {
        this.tab = "join";
      } else {
        this.tab = "introduction";
      }
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    tabClick(value) {
      this.$router.push(`/about/${value}`);
      this.tab = value;
    },

    async getCompany() {
      try {
        const query = {
          pageSize: this.page.perPage,
          current: this.page.current
        };
        const TeamData = await Api.Company.getTeam(query);
        this.teamData = TeamData;
        this.page.rows = TeamData.total;
      } catch (e) {
        this.$Message.error(e);
      }
    }
  }
};
</script>
